export const isDevEnvironment = () => ['development', 'test'].includes(process.env.NODE_ENV)
